import script from "./btnDropdownLogout.vue?vue&type=script&setup=true&lang=js"
export * from "./btnDropdownLogout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__